/**
 * Food Safety product analytics (Step 29).
 * Segment-style via window.analytics — never throws into kitchen flows.
 */

const trackFoodSafetyEvent = (eventName, properties = {}) => {
  try {
    if (typeof window !== 'undefined' && window.analytics?.track) {
      window.analytics.track(eventName, properties)
    }
  } catch (_) {
    // Analytics not available; ignore
  }
}

export const trackFoodSafetyOpened = properties =>
  trackFoodSafetyEvent('food_safety_opened', properties)

export const trackFoodSafetyLogSubmitted = properties =>
  trackFoodSafetyEvent('food_safety_log_submitted', properties)

export const trackFoodSafetyLogSkipped = properties =>
  trackFoodSafetyEvent('food_safety_log_skipped', properties)

export const trackFoodSafetySetupSaved = properties =>
  trackFoodSafetyEvent('food_safety_setup_saved', properties)

export const trackFoodSafetyReportsViewed = properties =>
  trackFoodSafetyEvent('food_safety_reports_viewed', properties)

export const trackFoodSafetyPaywallShown = properties =>
  trackFoodSafetyEvent('food_safety_paywall_shown', properties)

export const trackFoodSafetyPaywallUpgradeClicked = properties =>
  trackFoodSafetyEvent('food_safety_paywall_upgrade_clicked', properties)

export const trackFoodSafetySamplePdfPreviewed = properties =>
  trackFoodSafetyEvent('food_safety_sample_pdf_previewed', properties)

export const trackFoodSafetySamplePdfEmailed = properties =>
  trackFoodSafetyEvent('food_safety_sample_pdf_emailed', properties)

export const trackFoodSafetyReportEmailed = properties =>
  trackFoodSafetyEvent('food_safety_report_emailed', properties)

export const trackFoodSafetyReportShared = properties =>
  trackFoodSafetyEvent('food_safety_report_shared', properties)

export const trackFoodSafetyOllieOpened = properties =>
  trackFoodSafetyEvent('food_safety_ollie_opened', properties)
